import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Field } from 'redux-form';
import CheckBoxSelect from 'components/atoms/form/CheckBoxSelect';
import { supportedChannelDisplayNamesKeyed } from 'helpers/channels';

const fields = Object.keys(supportedChannelDisplayNamesKeyed).map((channel, index) => (
    <Col key={index} md={6}>
        <Field
            component={CheckBoxSelect}
            label={supportedChannelDisplayNamesKeyed[channel]}
            name={`meta.channelConfig.${channel}.enabled`}
            type="checkbox" />
    </Col>
));

function DefaultChannelsBlock() {
    return <Row>
        <Col md={12}>
            <Row>{fields}</Row>
        </Col>
    </Row>;
}
export default DefaultChannelsBlock;



// WEBPACK FOOTER //
// ./src/components/molecules/DefaultChannelsBlock.js